import VerifyEmailForm from '@/domains/auth/components/VerifyEmailForm';

export default function VerifyEmailPage() {
  return <VerifyEmailForm />;
}
